import { render, staticRenderFns } from "./InactiveComplaints.vue?vue&type=template&id=eea4a3ba&scoped=true&"
import script from "./InactiveComplaints.vue?vue&type=script&lang=js&"
export * from "./InactiveComplaints.vue?vue&type=script&lang=js&"
import style0 from "./InactiveComplaints.vue?vue&type=style&index=0&id=eea4a3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea4a3ba",
  null
  
)

export default component.exports